var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-checkbox"},[_c('input',{attrs:{"type":"checkbox","id":_vm.id},domProps:{"checked":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event.target.checked)}}}),_c('label',{staticClass:"checkbox-label",attrs:{"for":_vm.id}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }